import creased from './creased.jpg';
import lined from './lined.jpg';
import wrinkled from './wrinkled.jpg';


export default {
    creased, lined, wrinkled
}